import {RENDER_TEMPLATES} from "../../../../../constants";
import workspace from "../../workspace";
import sqftConfig from "../../../store/sqftConfig";
import COLOR_THEMES from "../../../store/colorThemes";
import store from "../../../../../../../store";

export default class ShapeEditable {
  __shape;

  constructor(shape) {
    this.__shape = shape;
  }

  render = (ctx, template= RENDER_TEMPLATES.default) => {
    if (workspace && workspace.getState().loading) return;
    let lines = this.__shape.getLines();

    ctx.beginPath();
    for (let i = 0; i < lines.length; i++) {
      lines[i].render(ctx, i > 0);
    }
    if (this.__shape.isHovering() && workspace.getHoverShape() === this.__shape ) {
      ctx.strokeStyle = COLOR_THEMES[sqftConfig.activeTheme].active_hover;
    } else {
      ctx.strokeStyle = COLOR_THEMES[sqftConfig.activeTheme].active;
    }
    ctx.fillStyle = COLOR_THEMES[sqftConfig.activeTheme].active_disabled;
    switch (template) {
      case RENDER_TEMPLATES.linesOnly:
        ctx.lineWidth = 0;
        ctx.closePath();
        break;
      case RENDER_TEMPLATES.default:
      default:
        //ctx.fill();
        ctx.lineWidth = 2; // Math.ceil(scale);
        ctx.closePath();
        ctx.stroke();
        break;
    }

    if (this.__shape.isHovering() && workspace.getHoveredSqftShape() === this.__shape ) {
      let sqftMenuState = store.getState().sqftMenuState;
      void sqftMenuState;
    }
  };

  // renderLinesBetweenPoints = (ctx) => {
  //   ctx.beginPath();
  //   ctx.lineWidth = lineWidth;
  //   ctx.strokeStyle = color;
  //   drawLines(ctx);
  //
  //   ctx.stroke();
  // };
}
